export default function Footer() {
  return (
    <footer className="relative z-10 border-t border-white/10 backdrop-blur-md bg-black/30 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center">
        <p className="text-gray-400">© 2024 Nausher Ali | Software Engineer & Designer</p>
        <p className="text-gray-500 text-sm mt-2">Crafted with passion using React & Tailwind CSS</p>
      </div>
    </footer>
  );
}
